import { fetch } from '@/hotelcem/apis/request'
const baseURL = `${process.env.VUE_APP_APIBASEURL}/api/v1`

function fecthGet(url, params = {}, config = {}) {
  return fetch({
    baseURL,
    url,
    method: 'GET',
    params: params,
    ...config,
  })
}

function fecthPost(url, params = {}, config = {}) {
  return fetch({
    baseURL,
    url,
    method: 'POST',
    data: params,
    ...config,
  })
}

export default {
  // 今日csi得分
  getTodayCsiScore(params) {
    return fecthPost('/cem-4x/home-page/important-index', params)
  },

  // 渠道得分
  getChannelScore(params) {
    return fecthPost('/cem-4x/home-page/channel-index', params)
  },

  // 新增点评量及回复率
  getNewCommentAndReplyRate(params) {
    return fecthPost('/cem-4x/home-page/new/comment/count', params)
  },

  // 新增点评均分
  getNewCommentAverageScore(params) {
    return fecthPost('/cem-4x/home-page/new/comment/score/detail', params)
  },

  // 新增语音和客诉
  getNewVoiceAndComplaint(params) {
    return fecthPost('/cem-4x/home-page/new/voice/detail', params)
  },

  // 客诉预警查看率及一次解决率
  getComplaintWarningViewRateAndOneTimeSolveRate(params) {
    return fecthPost('/cem-4x/home-page/voice/viewing-solverate', params)
  },

  // 点评问题分布 观点量、表扬率
  getCommentProblem(params) {
    return fecthPost('/cem-4x/home-page/comment/label/info', params)
  },

  // 点评问题分布 批评率
  getCommentProblemNeg(params) {
    return fecthPost('/cem-4x/home-page/comment/label/neg/info', params)
  },

  // 客诉问题分布
  getComplaintProblem(params) {
    return fecthPost('/cem-4x/home-page/voice/complaint-distribution', params)
  },

  // 客诉房间分布
  getComplaintProblemRoom(params) {
    return fecthPost('/cem-4x/home-page/voice/complaint/room-distribution', params)
  },

  // 竞争分析
  getCompetitionAnalysis(params) {
    return fecthPost('/cem-4x/home-page/comment/competition-index', params)
  },
  // 点评问题分布 --- 一级观点对比
  getCommentProblemDistributionByFirstView(params) {
    return fecthPost('/cem-4x/home-page/comment/problem-distribution', params)
  },
  // 竞对酒店列表
  getCompeteHotelList(params) {
    return fecthGet('/cem-4x/hotel-info/rival-hotel/list', params)
  },
  // 竞对酒店TOP10观点
  getCompeteHotelTop10Viewpoint(params) {
    return fecthPost('/cem-4x/home-page/comment/competitor-label/rank', params)
  },

  // 连续无差评天数
  getContinuousNoBadCommentDays(params) {
    return fecthPost('/cem-4x/home-page/hotel/pos/days', params)
  },
  /**
   * @description cem到期功能列表
   * @param {*} params
   * @param {String} params.hotelId 酒店id
   * @param {String} params.language 语言
   * @returns
   */
  getExpireNotice(params) {
    return fecthPost('/cem-4x/home-page/app/expire-notice/list', params)
  },
  /**
   * @description cem关闭即将到期功能提醒
   * @param {*} params
   * @param {String} params.hotelId 酒店id
   * @param {String} params.language 语言
   * @param {Number} params.serverNum 续签个数
   * @param {Boolean} params.refuseNotice 下次不再通知
   * @returns
   */
  closeExpireNotice(params) {
    return fecthPost('/cem-4x/home-page/app/expire-notice/close', params)
  },
  /**
   * @description cem到期功能列表 申请签名
   * @param {*} params
   * @param {String} params.hotelId 酒店id
   * @param {String} params.language 语言
   * @param {Number} params.serverNum 续签个数
   * @param {Boolean} params.refuseNotice 下次不再通知
   * @returns
   */
  applySign(params) {
    return fecthPost('/cem-4x/home-page/app/expire-notice/apply-sign', params)
  },
}
